__turbopack_context__.v({
  "button": "VqmjoG_button",
  "contractDetails": "VqmjoG_contractDetails",
});
